var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('div',{staticClass:"app-container"},[_c('div',{staticClass:"headBar-block"},[_c('HeadBar')],1),_vm._v(" "),_c('div',{staticClass:"operation-block"},[_c('div',{staticClass:"operation-block-ui"},[_c('router-view')],1)]),_vm._v(" "),_c('div',{staticClass:"footer-block"},[_c('Footer')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bbedd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/layout.vue
// module id = null
// module chunks = 